"use strict";

// proptypes are in mixin
/* eslint react/prop-types:0*/
import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import createReactClass from "create-react-class";
import Button from "../../../../Styled/Button";
import Icon from "../../../../Styled/Icon";
import BaseOuterPanel from "../BaseOuterPanel";
import InnerPanel from "../InnerPanel";
import { StyledIcon } from "../../../../Styled/Icon";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const StorySharePanel = createReactClass({
  displayName: "StorySharePanel",
  mixins: [BaseOuterPanel],
  getInitialState() {
    return {
      localIsOpen: false,
      caretOffset: undefined,
      dropdownOffset: undefined
    };
  },
  onInnerMounted(innerElement) {
    if (innerElement) {
      this.setState({
        caretOffset: "0px",
        dropdownOffset: "0px"
      });
    } else {
      this.setState({
        caretOffset: undefined,
        dropdownOffset: undefined
      });
    }
  },
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.forceClosed) {
      this.onDismissed();
    }
  },
  openWithUserClick(e) {
    if (this.props.onUserClick) {
      this.props.onUserClick();
    }
    this.openPanel(e);
  },
  onClose() {
    if (this.props.onUserClick) {
      this.props.onUserClick();
    }
    this.onDismissed();
  },
  render() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(_StyledButton, {
        disabled: this.props.btnDisabled,
        title: this.props.btnTitle,
        primary: true,
        renderIcon: () => /*#__PURE__*/_jsx(StyledIcon, {
          glyph: Icon.GLYPHS.share,
          light: true,
          styledWidth: "20px"
        }),
        textProps: {
          large: true
        },
        onClick: this.openWithUserClick,
        children: this.props.btnText ? this.props.btnText : ""
      }), this.isOpen() && /*#__PURE__*/_jsx(_StyledDiv, {
        children: /*#__PURE__*/_jsx(InnerPanel, {
          showDropdownAsModal: this.props.showDropdownAsModal,
          modalWidth: this.props.modalWidth,
          onDismissed: this.onClose,
          innerRef: this.onInnerMounted,
          doNotCloseFlag: this.getDoNotCloseFlag(),
          theme: this.props.theme,
          caretOffset: this.state.caretOffset,
          dropdownOffset: this.state.dropdownOffset,
          children: this.props.children
        })
      })]
    });
  }
});
export default StorySharePanel;
var _StyledButton = _styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            flex-shrink: 0;\n          "])));
var _StyledDiv = _styled2("div").withConfig({
  displayName: "StorySharePanel___StyledDiv",
  componentId: "sc-147uehk-0"
})(["margin-top:35px;font-family:", ";"], p => p.theme.fontBase);